import TransportOrderCard from './TransportOrderCard'

export default TransportOrderCard
